import React, { Component } from 'react';
import { connect } from 'react-redux';

class ProductDetailPreorderMessage extends Component {
  render() {
    let { customer, upgradeStatus, isLoggedIn, store, oProduct, availableForBundle, prettyPubDate, isFeaturedSelection } = this.props;

    let nonBundleClub       = (!store.bundle_pricing) ? true : false;
    let todaysTime      = new Date().getTime();
    let pubTime         = new Date(oProduct.available_date).getTime();
    let presales            = store.tla === "DVD" ? "Pre-orders" : "Presales";
    let Featured            = store.tla === "DVD" ? "Director's" : "Featured";
    const daysToRelease = Math.ceil(((pubTime - todaysTime) / 3600000)/24);

    // Check if pub date is in future
    if (daysToRelease > 1){
      if (daysToRelease < 7 || isFeaturedSelection) {
        if (nonBundleClub) {
          return (
            <div className="bordered-box">
              <strong>Release Date: <span className="no-wrap">{prettyPubDate}</span></strong><br />
              Due to the future release date, an order which includes this title will not ship until {prettyPubDate}.
            </div>
          );
        } else {
          return (
            <div className="bordered-box">
              <strong>Release Date: <span className="no-wrap">{prettyPubDate}</span></strong><br />
              Due to the future release date, a bundle which includes this title will not ship until {prettyPubDate}.
            </div>
          );
        }
      }
      if (daysToRelease >= 7){
        if( isLoggedIn && customer.status === 'Active' && !upgradeStatus){
          if (nonBundleClub) {
            return (
              <div className="bordered-box">
                <strong>Release Date: <span className="no-wrap">{prettyPubDate}</span></strong><br />
                This title is a pre-order and will be shipped separately from the other items in your box.
              </div>
            );
          } else {
            return (
              <div className="bordered-box">
                <strong>Release Date: <span className="no-wrap">{prettyPubDate}</span></strong><br />
                You can add this title to your {Featured} Selection Bundle on <span className="no-wrap">{availableForBundle}</span>.
              </div>
            );
          }
        } else {
          // Logged out message
          return (
            <div className="bordered-box">
              <strong>Release Date: <span className="no-wrap">{prettyPubDate}</span></strong><br />
                {presales} available for members only.
                To purchase this title, please <a onClick={() => dispatch(openLoginModal() )}>log in</a> or <a onClick={() => dispatch( openCartModal() )}>join now</a>.
            </div>
          );
        }
      }
    }
    return <div />;
  }
};

function mapStateToProps(state){
    return {
      'customer': state.customer,
      'store': state.store,
      'isLoggedIn': state.isLoggedIn,
      'upgradeStatus': state.upgradeStatus
    };
}

export default connect(mapStateToProps)(ProductDetailPreorderMessage);


// WEBPACK FOOTER //
// ./src/components/ProductDetailPreorderMessage.jsx